import { createStore } from 'zustand'

import { ScanQrcodeStore } from './interface'

export const createScanQrcodeStore = () =>
  createStore<ScanQrcodeStore>((set, get) => ({
    qrcode: undefined,
    sceneId: undefined,
    openId: undefined,
    bound: false,
    status: 'loading',
    onScan: undefined,
    onReload: undefined,
    reloadApi: undefined,
    reloadQrcode() {
      set({ status: 'loading' })
      get().onReload?.()
      return get().reloadApi?.()
    },
    updateShowError(error) {
      if (error) {
        set({ status: 'error' })
      }
    },
    updateShowResult(result) {
      if (!result) {
        return
      }

      const { qrcode, sceneId } = result

      set({
        qrcode,
        sceneId
      })

      if (qrcode) {
        set({
          status: 'active'
        })
      }
    },
    updateScanResult(result) {
      if (!result) {
        return
      }

      const { bound, expired, openId } = result

      if (expired) {
        set({ sceneId: undefined, status: 'expired' })
      } else {
        set({ bound, openId })
        if (openId) {
          set({ sceneId: undefined, status: 'success' })
          get().onScan?.({ bound, openId })
        }
      }
    }
  }))
